export default __webpack_public_path__ + "09588c822abbfb4f73c2dde6c5f5ef2e.png";